import { render, staticRenderFns } from "./SelectVaultFileModal.vue?vue&type=template&id=b5207b4e"
import script from "./SelectVaultFileModal.vue?vue&type=script&lang=js"
export * from "./SelectVaultFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports